/**
 * @generated SignedSource<<0c2ce8eaeb3d474bf21881ee6839dbc3>>
 * @relayHash 1deebc45bb6aa17185df417dfe7a1a3b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 94a459c7a862943329a81fa40a56838962b33fb13e80648aead1dd017f68d95d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBoard_JiraBoardQuery } from './JiraBoard_JiraBoardQuery.graphql';

import isAutoManagedSprintsEnabled_provider from '@jira/board__relay-providers/src/AutoManagedSprintsForHarmonisedBoard';
import isBulkIssueActionsEnabled_provider from '@jira/board__relay-providers/src/BoardBulkIssueActionsEnabled';
import boardInlineAssignAgent_provider from '@jira/board__relay-providers/src/BoardInlineAssignAgent';
import shouldPublishRovoBoardContext_provider from '@jira/board__relay-providers/src/BoardRovoContextualActions';
import withSwimlanesChangeboarding_provider from '@jira/board__relay-providers/src/SwimlanesChangeboarding';
import withTmpHarmonisationOnboarding_provider from '@jira/board__relay-providers/src/TmpHarmonisationOnboarding';

const node: PreloadableConcreteRequest<JiraBoard_JiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "94a459c7a862943329a81fa40a56838962b33fb13e80648aead1dd017f68d95d",
    "metadata": {},
    "name": "JiraBoard_JiraBoardQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraboard__relayproviderssrcSwimlanesChangeboardingtsx": withSwimlanesChangeboarding_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcTmpHarmonisationOnboardingtsx": withTmpHarmonisationOnboarding_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcAutoManagedSprintsForHarmonisedBoardtsx": isAutoManagedSprintsEnabled_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcBoardRovoContextualActionstsx": shouldPublishRovoBoardContext_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcBoardBulkIssueActionsEnabledtsx": isBulkIssueActionsEnabled_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcBoardInlineAssignAgenttsx": boardInlineAssignAgent_provider
    }
  }
};

export default node;
